import React from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import { Box, Stack, Link } from '@mui/material';
import ProfileCustomClearIcon from '../../../HelperIcons/ProfileCustomClearIcon';

const SocialPanel = ({ field, index, shudClearBtnRender, handleFieldChange, handleClearField }) => {
  const isHttpValid = (str) => {
    try {
      const newUrl = new URL(str);
      return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    } catch (err) {
      return false;
    }
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" sx={{ '& img': {width: '1.2rem', borderRadius: '3px'}}} padding={1}>
        {field.icon}
        <Typography variant="body1" sx={{ flexGrow: 1, marginLeft: 1, color: '#727484', fontFamily: 'Figtree-Regular' }}>
          {field.name}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" padding={1} paddingTop={0}>
        <Typography variant="body1" sx={{ minWidth: '80px', color: '#B2B4C5', fontFamily: 'Figtree-Regular' }}>
          Profile link
        </Typography>
        {field.disabled ? (
          isHttpValid(field.value) ? (
            <Link
              href={field.value}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                flexGrow: 1,
                color: '#727484',
                textDecoration: 'none',
                padding: '10px',
                wordBreak: 'break-all',
                whiteSpace: 'normal',
                fontFamily: 'Figtree-Regular',
              }}
            >
              {field.value}
            </Link>
          ) : (
            <Typography sx={{ fontFamily: 'Figtree-Regular', wordBreak: 'break-all', padding: '10px', whiteSpace: 'normal',}}>{field.value}</Typography>
          )
        ) : (
          <TextField
            fullWidth
            margin="normal"
            placeholder=""
            value={field.value}
            onChange={(e) => handleFieldChange(index, e)}
            disabled={field.disabled}
            sx={{
              marginTop: 0,
              marginBottom: 0,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'transparent',
                  border: 'none',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                  border: 'none',
                },
              },
              '& .MuiInputBase-root': {
                borderBottom: field.disabled ? 'none' : '2px solid #E7E7E7',
                borderRadius: field.disabled ? 'initial' : 0,
                fontFamily: 'Figtree-Regular',
              },
              '& .MuiInputBase-input': {
                color: '#727484',
                fontFamily: 'Figtree-Regular',
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {shudClearBtnRender && (
                    <IconButton
                      aria-label="clear"
                      onClick={(e) => handleClearField(index, e)}
                      edge="end"
                    >
                      <ProfileCustomClearIcon
                        sx={{
                          backgroundColor: field.disabled ? 'transparent' : 'lightgrey',
                          color: 'white',
                          borderRadius: '50%',
                          width: '18px',
                          height: '18px',
                        }}
                      />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
        )}
      </Stack>
      <Divider />
    </Box>
  );
};

export default SocialPanel;
